import { useMutation, useQueryClient } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'

export function useFinalizeWitnessAgreement(id_client: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await publicApi.post(`/agreement/${id_client}/finalize-witness`)

      if (!response.data) {
        throw new Error('Erro ao finalizar a minuta com testemunha')
      }

      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
